import React, { useRef } from 'react'
import DeleteLabel from './deleteLabel';
import useFitToViewport from '../../../hooks/useFitToViewport';

export default function SearchLabelsBlk({userLabels,handleShowEditLabel,renderLabels,addLabelToProperties,setAddLabelToProperties,selectedPropertyIds,selectedPropertyTitles,handleChangePropertyLabel,propertyLabel,addLabelsToProperties,editLabel,handleCloseEditLabel,labelName,handleChangeEditLabel,labelColor,setUserLabels,setEditLAbel,updateLabel,showLabelInput,showNewLabelInput,handleLabelNameChange,handleLabelColorChange,postLabel,newLabelName,newLabelColor,labelBusy}) {
  // The assign and edit popups sit over this menu without covering its bottom,
  // so the "New label +" form (and its own Save) stays out while either is open.
  const popupOpen = addLabelToProperties === true || editLabel?.show === true;
  const busy = Boolean(labelBusy);
  const spinner = (kind) => (labelBusy === kind ? <i className="spinner"></i> : '');
  // Keeps the menu on screen; the label list scrolls inside it (see .label_menu).
  const menuRef = useRef(null);
  useFitToViewport(menuRef);

  return (
    <div ref={menuRef} className={popupOpen ? "label_menu popup_open" : "label_menu"}>
    <div className="head_label_flex">
                      <span>Label properties</span>
                      <input type="text" defaultValue={"1"} />
                      <span>to</span>
                      <input type="text" defaultValue={"2"} />
                    </div>
                    <div className="flex_label_new_new">
                      <div className="col_left_lbl">
                        {userLabels.map((label) => (
                          <div className="_col_left" key={label.id}>
                            <div
                              className={`label_btn ${label.label_color}`}
                              style={{ backgroundColor: label.label_color,color: label.is_dark ? "#fff" : "#000" }}
                            >
                              <span>{label.label_name}</span>
                              {/* <span>(2)</span> */}
                            </div>
                            <div className="col_right_lbl">
                              <button
                                type="button"
                                onClick={(e) => handleShowEditLabel(e, label)}
                              >
                                <img src="/images/pencil.svg" alt="" />
                              </button>
                            </div>
                          </div>
                        ))}
                        {renderLabels()}
                      </div>
                    </div>
                    {addLabelToProperties === true ? (
                      <div className="new_label_new_new edit_label">
                        <div
                          className="crosBtn"
                          onClick={() => setAddLabelToProperties(false)}
                        >
                          x
                        </div>
                        <h5>Selected Properties are:</h5>
                        <div className="selected_properties">
                          {" "}
                          {selectedPropertyIds?.length > 0 ? (
                            <>
                              {selectedPropertyTitles?.map(
                                (selectedPropertyTitle, index) => {
                                  return <span key={index}>{selectedPropertyTitle}</span>;
                                }
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="flex custom_choose_lbl">
                          <label>Select Label:</label>
                          {/* Controlled, with a placeholder: the browser used to show the
                              first label as chosen while nothing was actually selected. */}
                          <select
                            name=""
                            className="input"
                            value={propertyLabel}
                            onChange={handleChangePropertyLabel}
                          >
                            <option value="" disabled>
                              Choose a label
                            </option>
                            {userLabels.map((label) => (
                              <option key={label?.id} value={label?.id}>
                                {label?.label_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <button
                          type="button"
                          onClick={addLabelsToProperties}
                          className="site_btn"
                          disabled={busy}
                        >
                          Save {spinner("assign")}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                    {editLabel?.show === true && editLabel?.item !== null ? (
                      <div className="new_label_new_new edit_label">
                        <div className="crosBtn" onClick={handleCloseEditLabel}>
                          x
                        </div>
                        <div className="flex">
                          <input
                            type="text"
                            name="label_name"
                            placeholder="Label Name"
                            value={labelName}
                            className="input"
                            onChange={handleChangeEditLabel}
                          />

                          <input
                            type="color"
                            name="label_color"
                            value={labelColor}
                            className="new_clr_choose"
                            onChange={handleChangeEditLabel}
                          />
                        </div>
                        <div className="btnBlk flex">
                          <DeleteLabel
                            label_id={editLabel?.item?.id}
                            setUserLabels={setUserLabels}
                            setEditLAbel={setEditLAbel}
                          />
                          <button
                            type="button"
                            onClick={(e) => updateLabel(e, editLabel?.item?.id)}
                            className="site_btn"
                            disabled={busy}
                          >
                            Save {spinner("update")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {!popupOpen && (
                    <div className="new_lbl_plus_sign">
                      <button onClick={showLabelInput}>New label +</button>
                      {showNewLabelInput && (
                        <div className="new_label_new_new">
                          <div className="flex">
                            <input
                              type="text"
                              name="label_name"
                              placeholder="Label Name"
                              value={newLabelName}
                              className="input"
                              onChange={handleLabelNameChange}
                            />

                            <input
                              type="color"
                              name="label_color"
                              value={newLabelColor}
                              className="new_clr_choose"
                              onChange={handleLabelColorChange}
                            />
                          </div>
                          <button
                            type="button"
                            onClick={postLabel}
                            className="site_btn"
                            disabled={busy}
                          >
                            Save {spinner("create")}
                          </button>
                        </div>
                      )}
                    </div>
                    )}
                    {editLabel?.show !== true &&
                    editLabel?.item === null &&
                    addLabelToProperties !== true ? (
                      <div className="add_label_selected_props flex">
                        {selectedPropertyIds?.length > 0 ? (
                          <button
                            className="site_btn"
                            type="button"
                            onClick={() => setAddLabelToProperties(true)}
                          >
                            Add Label to selected properties
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )}
    </div>
  )
}
